var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.203,
    height: 22.692,
    viewBox: "0 0 28.203 22.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3373",
    "data-name": "Rectangle 3373",
    width: 28.203,
    height: 22.692,
    fill: "#d62828"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10208",
    "data-name": "Group 10208",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10065",
    "data-name": "Group 10065",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27144",
    "data-name": "Path 27144",
    d: "M27.708,16.5,23.32,13.09a1.273,1.273,0,0,0-.57-.25l-1.572-1.221c.031-.359.047-.722.047-1.088C21.225,6.974,19.074,0,14.1,0,11.836,0,9.85,1.509,8.509,4.25a15.479,15.479,0,0,0-1.53,6.281c0,.365.016.729.047,1.088L5.454,12.84a1.275,1.275,0,0,0-.57.25L.5,16.5A1.28,1.28,0,0,0,0,17.51V21.4a1.281,1.281,0,0,0,1.279,1.281l3.9.006h0a1.281,1.281,0,0,0,.961-.434l3.651-4.145a1.272,1.272,0,0,0,.263-.473l.535-.607a9.373,9.373,0,0,0,.953.054A3.079,3.079,0,0,0,14.1,15.46a3.08,3.08,0,0,0,2.556,1.626,9.373,9.373,0,0,0,.953-.054l.535.607a1.275,1.275,0,0,0,.263.473l3.652,4.145a1.28,1.28,0,0,0,.961.434h0l3.9-.006A1.281,1.281,0,0,0,28.2,21.4V17.51a1.281,1.281,0,0,0-.495-1.011M4.6,20.129l-2.043,0v-1.99l3-2.33,1.516,1.516Zm8.135-9.6c0,2.5-.867,3.877-1.207,3.994a8.682,8.682,0,0,1-.956-.081,1.281,1.281,0,0,0-1.423.347l-.461.523-.983-.983L9.168,13.2a1.28,1.28,0,0,0,.48-1.2,9.747,9.747,0,0,1-.109-1.462c0-2.012,1.106-6.307,3.261-7.6-.024,2.091-.061,5.634-.061,7.6m4.887,3.913a8.686,8.686,0,0,1-.957.081c-.34-.117-1.207-1.5-1.207-3.994,0-1.962-.037-5.508-.061-7.6a5.789,5.789,0,0,1,1.992,2.444,13.121,13.121,0,0,1,1.269,5.155,9.71,9.71,0,0,1-.109,1.462,1.281,1.281,0,0,0,.48,1.2l1.459,1.134-.983.984-.461-.523a1.28,1.28,0,0,0-1.423-.347m8.015,5.682-2.043,0-2.473-2.807,1.516-1.516,3,2.33Z",
    transform: "translate(0 0)",
    fill: "#d62828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandImg2);
export default __webpack_public_path__ + "static/media/hand-img2.2f377b391edbf01bc3828f51534ee24f.svg";
export { ForwardRef as ReactComponent };